import { FC, useMemo } from "react";
import styles from "./styles.module.scss";

const WidgetSkeleton: FC = () => (
  <div className={styles.widgetSkeleton}>
    <div className={styles.widgetHeader}>
      <div className={styles.titleSkeleton} />
      <div className={styles.iconSkeleton} />
    </div>
    <div className={styles.percentSkeleton} />
  </div>
);

interface GroupSkeletonProps {
  count?: number;
  withHeader?: boolean;
}

export const GroupSkeleton: FC<GroupSkeletonProps> = ({
  count = 4,
  withHeader = false,
}) => {
  const keys = useMemo(
    () => Array.from({ length: count }, () => crypto.randomUUID()),
    [count],
  );

  return (
    <div className={styles.groupSkeleton}>
      {withHeader && (
        <div className={styles.groupHeaderSkeleton}>
          <div className={styles.groupTitleSkeleton} />
          <div className={styles.groupIconSkeleton} />
        </div>
      )}
      <div className={styles.widgetsContainer}>
        {keys.map((key) => (
          <div key={key} className={styles.widgetWrapper}>
            <WidgetSkeleton />
          </div>
        ))}
      </div>
    </div>
  );
};
